// extracted by mini-css-extract-plugin
module.exports = {"content":"content-3JYY2","footer":"footer-2O1lJ"};